import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CHA003_Request,
  IAPI_CHA003_Response,
  IAPI_CHA004_Request,
  IAPI_CHA004_Response,
  IAPI_ACC003_Request,
  IAPI_ACC003_Response,
  IAPI_CHA001_Request,
  IAPI_CHA001_Response,
  IAPI_CHA002_Request,
  IAPI_CHA002_Response,
} from "../../../type/apiType";

// スレッド詳細一覧参照API
const httpAPI_CHA003 = async (
  param: IAPI_CHA003_Request
): Promise<IAPI_CHA003_Response> => {
  let res = await http.post(ApiUrl.API_CHA003, {
    ...param,
  });
  return res.data;
};

// スレッド詳細更新API
const httpAPI_CHA004 = async (
  param: IAPI_CHA004_Request
): Promise<IAPI_CHA004_Response> => {
  let res = await http.post(ApiUrl.API_CHA004, {
    ...param,
  });

  return res.data;
};

// 法人ユーザ一覧参照API
const httpAPI_ACC003 = async (
  param: IAPI_ACC003_Request
): Promise<IAPI_ACC003_Response> => {
  let res = await http.post(ApiUrl.API_ACC003, {
    ...param,
  });

  return res.data;
};

// スレッド一覧参照API
const httpAPI_CHA001 = async (
  param: IAPI_CHA001_Request
): Promise<IAPI_CHA001_Response> => {
  let res = await http.post(ApiUrl.API_CHA001, {
    ...param,
  });

  return res.data;
};

// スレッド更新API
const httpAPI_CHA002 = async (
  param: IAPI_CHA002_Request
): Promise<IAPI_CHA002_Response> => {
  let res = await http.post(ApiUrl.API_CHA002, {
    ...param,
  });

  return res.data;
};

export {
  httpAPI_CHA003,
  httpAPI_CHA004,
  httpAPI_ACC003,
  httpAPI_CHA001,
  httpAPI_CHA002,
};
